/**
 * Prevents form submission when Enter key is pressed in form fields
 * @param {KeyboardEvent} e - The keyboard event
 */
export const preventEnterFormSubmission = (e) => {
  // Prevent form submission on Enter key press, but allow it for submit buttons and specific components
  if (e.key === 'Enter' && e.target.type !== 'submit' && e.target.type !== 'button') {
    e.preventDefault();
  }
};
